__webpack_require__.p = "/getting-started-first-time-visited-tooltip/system-email-templates/";